import {
    BusinessObjectPart,
    BusinessObjectPartContext,
    ModelBase,
    ObservableCollection,
    QueryBus,
    Weaver
} from '@skylab-shared/core';
import { DocumentItemModel, VatReleaseReasonSource } from '@skylab-shared/dataModel';
import { RecursiveDiff } from '@skylab-shared/types';
import { VatReleaseReasonItem, VatReleaseReasonQuery } from '../../vat/queries/vat-release-reason.query-base';
import { DocumentInvalidVatReleaseReasonCustomNameError } from '../violations/document-invalid-vat-release-reason-custom-name-error';

export interface VatReleaseDocumentModelPart extends ModelBase {
    vatReleaseReasonId?: number;
    vatReleaseReasonCustomName?: string;
    vatReleaseReasonSource?: VatReleaseReasonSource;
    issuedByVatPayer: boolean;
    items: ObservableCollection<DocumentItemModel>
}

export class SaleDocumentVatReleaseBoPart extends BusinessObjectPart<VatReleaseDocumentModelPart> {
    public constructor(
        weaver: Weaver,
        protected readonly queryBus: QueryBus
    ) {
        super(weaver);
    }

    public override async initializeAsync(context: BusinessObjectPartContext<VatReleaseDocumentModelPart>): Promise<void> {
        await super.initializeAsync(context);

        const vatReleaseReasons = this.bo.localContext.getPreloaded(VatReleaseReasonQuery)!;

        this.engine.validation.addRule(
            [[this.modelType, 'vatReleaseReasonCustomName'], [this.modelType, 'vatReleaseReasonId']],
            [[this.modelType, 'vatReleaseReasonCustomName']],
            ctx => this.validateVatReleaseReasonCustomName(ctx.source, vatReleaseReasons),
            DocumentInvalidVatReleaseReasonCustomNameError
        );
    }

    public validateVatReleaseReasonCustomName(source: RecursiveDiff<VatReleaseDocumentModelPart, ModelBase>, vatReleaseReasons: VatReleaseReasonItem[]): boolean {
        if (source.vatReleaseReasonId === vatReleaseReasons.filter(x => x.customReleaseName)[0].id)
            return (source.vatReleaseReasonCustomName?.length ?? 0) > 0;
        return true;
    }
}
